import { Component, Input } from '@angular/core';
import { SelectFieldComponent } from '../../select-field/select-field.component';
import { FormControl } from '@angular/forms';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { DepartmentService } from '../../../../services/api/department.service';

@Component({
  selector: 'select-department-field',
  imports: [SelectFieldComponent],
  templateUrl: './select-department-field.component.html',
  styleUrl: './select-department-field.component.scss'
})
export class SelectDepartmentFieldComponent {
  @Input() label?: string;
  @Input() selectFormControl!: FormControl
  @Input() readonly!:boolean

  departments : any[] = [];

  options: { key: string, value: string }[] = []

  constructor(
    private departmentService: DepartmentService, 
    private alertNotificationService: AlertNotificationService
  )
  {}

  ngOnInit(): void {
    this.loadData()
  }

  public loadData(): void {
    this.departmentService.list()?.subscribe({
      next: (response: any) => {
        if (response && response.data && response.data.departments) {
          this.departments = response.data.departments;

          this.options = this.departments.map(d => ({
            key: d.departmentId,
            value: d.name
          }));
        }
      },
      error: (error: any) => {
        console.error('Errore durante il caricamento dello status:', error);
        this.alertNotificationService.error('Errore durante il caricamento dello status');
      }
    });
  }
}
